<div class="card card-custom">
  <div
    *ngIf="!patient"
    class="card-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="patientForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <kt-alert *ngIf="hasFormErrors" type="warn" [showCloseButton]="false" [duration]="10000">
        {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
      </kt-alert>
      <div *ngIf="patient">
        <table>
          <tr>
            <td>
              <span class="symbol symbol-70 symbol-light-warning">
                <span>
                  <div class="col-lg-9 col-xl-6">
                    <div
                      class="image-input image-input-outline image-input-changed gl-block"
                      style="background-image: url(/assets/media/users/blank.jpg)"
                    >
                      <div
                        class="image-input-wrapper"
                        [ngStyle]="{
                          'background-image': 'url(' + getPatientAvatarUrl(patient) + ')'
                        }"
                      ></div>
                    </div>
                  </div>
                </span>
              </span>
            </td>
            <td>
              <h3 class="card-label mr-0 gl-block">{{ getPatientName(patient) | titlecase }}</h3>
            </td>
          </tr>
        </table>
      </div>
      <div class="form-group">
        <div class="row">
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.FIRST_NAME' | translate }}</mat-label>
              <input matInput placeholder="Enter First Name" formControlName="first_name" />
              <mat-error
                >{{ 'PATIENT.INPUT.FIRST_NAME' | translate }}
                <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.MIDDLE_NAME' | translate }}</mat-label>
              <input matInput placeholder="Enter Middle Name" formControlName="middle_name" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.LAST_NAME' | translate }}</mat-label>
              <input matInput placeholder="Enter Last Name" formControlName="last_name" />
              <mat-error
                >{{ 'PATIENT.INPUT.LAST_NAME' | translate }}
                <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.LAST_NAME_2' | translate }}</mat-label>
              <input matInput placeholder="Enter Last Name 2" formControlName="last_name2" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.DOB' | translate }}</mat-label>
              <input matInput [matDatepicker]="dob" formControlName="dob" />
              <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
              <mat-datepicker #dob></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.GENDER' | translate }}</mat-label>
              <mat-select formControlName="gender">
                <mat-option value="MALE"> {{ 'PATIENT.INPUT.MALE' | translate }} </mat-option>
                <mat-option value="FEMALE"> {{ 'PATIENT.INPUT.FEMALE' | translate }} </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.PRIMARY_LANGUAGE' | translate }}</mat-label>
              <input
                matInput
                placeholder="Enter Primary Language"
                formControlName="primary_language"
              />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.PATIENT_CLASS' | translate }}</mat-label>
              <input matInput placeholder="Enter Patient Class" formControlName="patient_class" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <kt-general-autocomplete
              [label]="'PATIENT.INPUT.FACILITY' | translate"
              [loadItemsFunction]="facilityAutocompleteCall"
              [optionFormatter]="stringUtils.autocompleteEntityFormatter"
              [valueFormatter]="stringUtils.displayName"
              [required]="true"
              [readOnly]="patient"
              [control]="patientForm.get('facility_id')"
              [change]="onFacilityChange.bind(this)"
              [placeholder]="'Search Facilities'"
              [dataPath]="'data'"
              #facilityAutocomplete
            ></kt-general-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.URBANIZATION' | translate }}</mat-label>
              <input
                matInput
                placeholder="Enter Urbanization Code"
                formControlName="urbanization"
              />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.ADDRESS_1' | translate }}</mat-label>
              <input matInput placeholder="Enter Address 1" formControlName="address_1" />
              <mat-error
                >{{ 'PATIENT.INPUT.ADDRESS_1' | translate }}
                <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.ADDRESS_2' | translate }}</mat-label>
              <input matInput placeholder="Enter Address 2" formControlName="address_2" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.CITY' | translate }}</mat-label>
              <input matInput placeholder="Enter City" formControlName="city" />
              <mat-error
                >{{ 'PATIENT.INPUT.CITY' | translate }}
                <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.STATE' | translate }}</mat-label>
              <input matInput placeholder="Enter State" formControlName="state" maxlength="2" />
              <mat-error *ngIf="isControlHasError('state', 'pattern')">
                {{ 'AUTH.VALIDATION.INVALID_STATE' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.ZIP' | translate }}</mat-label>
              <input matInput maxlength="5" formControlName="zip" />
              <mat-error *ngIf="isControlHasError('zip', 'pattern')">
                Zip Code is invalid
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.HOME_PHONE' | translate }}</mat-label>
              <input
                matInput
                placeholder="Enter Home Phone"
                formControlName="home_phone"
                maxlength="14"
                ktAppPhoneMask
              />
              <mat-error *ngIf="isControlHasError('home_phone', 'pattern')">
                {{ 'PATIENT.INPUT.HOME_PHONE' | translate }}
                <strong>{{ 'PATIENT.VALIDATION.PATTERN' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.CELL_PHONE' | translate }}</mat-label>
              <input
                matInput
                placeholder="{{ 'PATIENT.PLACEHOLDER.CELL_PHONE' | translate }}"
                formControlName="cell_phone"
                maxlength="14"
                ktAppPhoneMask
              />
              <mat-error *ngIf="isControlHasError('cell_phone', 'pattern')">
                {{ 'PATIENT.INPUT.CELL_PHONE' | translate }}
                <strong>{{ 'PATIENT.VALIDATION.PATTERN' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.EMAIL' | translate }}</mat-label>
              <input matInput placeholder="Enter Email" formControlName="email" />
              <mat-error *ngIf="isControlHasError('email', 'email')">
                {{ 'PATIENT.INPUT.EMAIL' | translate }}
                <strong>{{ 'PATIENT.VALIDATION.EMAIL' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.FAX' | translate }}</mat-label>
              <input matInput placeholder="Enter Fax" formControlName="fax" />
              <mat-error *ngIf="isControlHasError('fax', 'pattern')">
                {{ 'PATIENT.INPUT.FAX' | translate }}
                <strong>{{ 'PATIENT.VALIDATION.FAX' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group row ml-5">
            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <div class="checkbox-list">
                <label class="checkbox">
                  <input type="checkbox" formControlName="hold_flag" />
                  <span></span>
                  {{ 'PATIENT.INPUT.HOLD_FLAG' | translate }}
                </label>
              </div>
            </div>
            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'PATIENT.INPUT.HOLD_DATE' | translate }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="hold_date"
                  formControlName="hold_date"
                  [readonly]="!patientForm.get('hold_flag').value"
                />
                <mat-datepicker-toggle
                  *ngIf="!patient"
                  matSuffix
                  [for]="hold_date"
                  [disabled]="!patientForm.get('hold_flag').value"
                ></mat-datepicker-toggle>
                <mat-datepicker #hold_date></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'PATIENT.INPUT.HOLD_NOTE' | translate }}</mat-label>
                <textarea
                  matInput
                  placeholder="Enter Hold Note"
                  formControlName="hold_note"
                  rows="1"
                  [readonly]="!patientForm.get('hold_flag').value"
                ></textarea>
              </mat-form-field>
            </div>
            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <div class="checkbox-list">
                <label class="checkbox">
                  <input type="checkbox" formControlName="in_hospital" />
                  <span></span>
                  {{ 'PATIENT.INPUT.IN_HOSPITAL' | translate }}
                </label>
              </div>
            </div>
            <div class="col-lg-8 kt-margin-bottom-20-mobile">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>{{ 'PATIENT.INPUT.IN_HOSPITAL_DATE' | translate }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="in_hospital_date"
                  formControlName="in_hospital_date"
                  [readonly]="!patientForm.get('in_hospital').value"
                />
                <mat-datepicker-toggle
                  *ngIf="!patient"
                  matSuffix
                  [for]="in_hospital_date"
                  [disabled]="!patientForm.get('in_hospital').value"
                ></mat-datepicker-toggle>
                <mat-datepicker #in_hospital_date></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-lg-4 kt-margin-bottom-20-mobile">
              <div class="checkbox-list">
                <label class="checkbox">
                  <input type="checkbox" formControlName="is_active" />
                  <span></span>
                  {{ 'PATIENT.INPUT.IS_ACTIVE' | translate }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer" *ngIf="!patient">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            (click)="close()"
            type="button"
            mat-raised-button
            cdkFocusInitial
            matTooltip="Cancel"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            [disabled]="clicked"
            (click)="onSubmit()"
            matTooltip="Create"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
